import { TableCell, TableRow, Box, IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FullUserDataFragment } from '../../../api';

import useCommonStyles from '../../../useCommonStyles';

export type UsersRowProps = {
    user: FullUserDataFragment;
    openEditForm: () => void;
};

const UsersRow = ({ user, openEditForm }: UsersRowProps) => {
    const { t } = useTranslation(['usersPage']);
    const commonStyles = useCommonStyles();

    const getAdditionalInfo = useCallback((userInfo: FullUserDataFragment) => {
        switch (userInfo.__typename) {
            case 'SaleConsultantUser':
                return userInfo.brand;
            case 'DealerUser':
                return (
                    <>
                        {userInfo.business.name}, {userInfo.business.registrationNumber}, {userInfo.business.address}
                    </>
                );
            default:
                return '';
        }
    }, []);

    return (
        <TableRow className={commonStyles.tableRow}>
            <TableCell>{user.fullName}</TableCell>
            <TableCell>{user.email}</TableCell>
            <TableCell>{user.mobilePhone.number}</TableCell>
            <TableCell>{user.type}</TableCell>
            <TableCell>{getAdditionalInfo(user)}</TableCell>
            <TableCell>{t('common:formats.shortDate', { date: new Date(user.registeredAt) })}</TableCell>
            <TableCell>
                <Box className={commonStyles.buttonGroup}>
                    <IconButton color="secondary" onClick={openEditForm}>
                        <EditIcon />
                    </IconButton>
                </Box>
            </TableCell>
        </TableRow>
    );
};

export default UsersRow;
